function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Dynamics365BC = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_6155_3246)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "mask0_6155_3246",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "40",
      height: "40",
      children: /*#__PURE__*/_jsx("path", {
        d: "M40 0H0V40H40V0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_6155_3246)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask1_6155_3246",
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20C0 21.7719 1.22893 23.2568 2.88094 23.6488C4.30979 30.3855 9.61454 35.6902 16.3512 37.119C16.7432 38.7711 18.2281 40 20 40C21.7719 40 23.2568 38.7711 23.6488 37.119C30.3855 35.6902 35.6902 30.3855 37.119 23.6488C38.771 23.2568 40 21.772 40 20C40 18.2282 38.7711 16.7433 37.1191 16.3512C35.6903 9.61454 30.3855 4.30979 23.6488 2.88094C23.2568 1.22893 21.7719 0 20 0C18.2281 0 16.7432 1.22893 16.3512 2.88094C9.6145 4.30979 4.30979 9.61454 2.88094 16.3512C1.22893 16.7432 0 18.2281 0 20Z",
          fill: "#8DF7DB"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask1_6155_3246)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
          fill: "url(#paint0_linear_6155_3246)"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.6667 7.11021C22.9014 6.49658 23.75 5.22237 23.75 3.75C23.75 1.67893 22.0711 0 20 0C17.9289 0 16.25 1.67893 16.25 3.75C16.25 5.22237 17.0985 6.49658 18.3333 7.11021V9.58333H21.6667V7.11021Z",
          fill: "#9DF3F9"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.3333 32.8898C17.0986 33.5034 16.25 34.7776 16.25 36.25C16.25 38.3211 17.9289 40 20 40C22.0711 40 23.75 38.3211 23.75 36.25C23.75 34.7776 22.9014 33.5034 21.6667 32.8898V30.4167H18.3333V32.8898Z",
          fill: "#82EBF1"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.11021 18.3333C6.49658 17.0986 5.22237 16.25 3.75 16.25C1.67893 16.25 -9.05296e-08 17.9289 0 20C9.05292e-08 22.0711 1.67893 23.75 3.75 23.75C5.22237 23.75 6.49658 22.9014 7.11021 21.6667H9.58333V18.3333H7.11021Z",
          fill: "#9DF3F9"
        }), /*#__PURE__*/_jsxs("g", {
          filter: "url(#filter0_f_6155_3246)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M20.0001 31.6667C25.9832 31.6667 30.8334 26.8164 30.8334 20.8333C30.8334 14.8502 25.9832 10 20.0001 10C14.017 10 9.16675 14.8502 9.16675 20.8333C9.16675 26.8164 14.017 31.6667 20.0001 31.6667Z",
            fill: "black",
            fillOpacity: "0.32"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.7155 22.5C24.0291 24.442 22.177 25.8334 20 25.8334C17.2386 25.8334 15 23.5948 15 20.8334C15 18.072 17.2386 15.8334 20 15.8334C22.177 15.8334 24.0291 17.2247 24.7155 19.1667H33.3333V22.5H24.7155Z",
            fill: "black",
            fillOpacity: "0.32"
          }), /*#__PURE__*/_jsx("path", {
            d: "M36.25 24.5834C34.1789 24.5834 32.5 22.9045 32.5 20.8334C32.5 18.7623 34.1789 17.0834 36.25 17.0834C38.3211 17.0834 40 18.7623 40 20.8334C40 22.9045 38.3211 24.5834 36.25 24.5834Z",
            fill: "black",
            fillOpacity: "0.32"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          filter: "url(#filter1_f_6155_3246)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M20.0001 30.9917C25.9832 30.9917 30.8334 26.1414 30.8334 20.1583C30.8334 14.1752 25.9832 9.325 20.0001 9.325C14.017 9.325 9.16675 14.1752 9.16675 20.1583C9.16675 26.1414 14.017 30.9917 20.0001 30.9917Z",
            fill: "black",
            fillOpacity: "0.24"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.7155 21.825C24.0291 23.767 22.177 25.1584 20 25.1584C17.2386 25.1584 15 22.9198 15 20.1584C15 17.397 17.2386 15.1584 20 15.1584C22.177 15.1584 24.0291 16.5497 24.7155 18.4917H33.3333V21.825H24.7155Z",
            fill: "black",
            fillOpacity: "0.24"
          }), /*#__PURE__*/_jsx("path", {
            d: "M36.25 23.9084C34.1789 23.9084 32.5 22.2295 32.5 20.1584C32.5 18.0873 34.1789 16.4084 36.25 16.4084C38.3211 16.4084 40 18.0873 40 20.1584C40 22.2295 38.3211 23.9084 36.25 23.9084Z",
            fill: "black",
            fillOpacity: "0.24"
          })]
        }), /*#__PURE__*/_jsx("path", {
          d: "M20.0001 30.8333C25.9832 30.8333 30.8334 25.9831 30.8334 20C30.8334 14.0169 25.9832 9.16667 20.0001 9.16667C14.017 9.16667 9.16675 14.0169 9.16675 20C9.16675 25.9831 14.017 30.8333 20.0001 30.8333Z",
          fill: "url(#paint1_linear_6155_3246)"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24.7155 21.6667C24.0291 23.6087 22.177 25 20 25C17.2386 25 15 22.7615 15 20C15 17.2386 17.2386 15 20 15C22.177 15 24.0291 16.3914 24.7155 18.3334H33.3333V21.6667H24.7155Z",
          fill: "url(#paint2_linear_6155_3246)"
        }), /*#__PURE__*/_jsx("path", {
          d: "M36.25 23.75C34.1789 23.75 32.5 22.0711 32.5 20C32.5 17.929 34.1789 16.25 36.25 16.25C38.3211 16.25 40 17.929 40 20C40 22.0711 38.3211 23.75 36.25 23.75Z",
          fill: "url(#paint3_linear_6155_3246)"
        })]
      })]
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_f_6155_3246",
      x: "5.83341",
      y: "6.66667",
      width: "37.4999",
      height: "28.3333",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "1.66667",
        result: "effect1_foregroundBlur_6155_3246"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_f_6155_3246",
      x: "8.85008",
      y: "9.00833",
      width: "31.4666",
      height: "22.3",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "0.158333",
        result: "effect1_foregroundBlur_6155_3246"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_6155_3246",
      x1: "9.45946",
      y1: "4.72975",
      x2: "30.2703",
      y2: "35.2703",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#009CA8"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#007D85"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_6155_3246",
      x1: "13.2433",
      y1: "10.946",
      x2: "27.5677",
      y2: "34.7298",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#36E3EE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#00B1BE"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_6155_3246",
      x1: "12.973",
      y1: "10",
      x2: "31.3514",
      y2: "26.4865",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#D2F6F9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#82EBF1"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint3_linear_6155_3246",
      x1: "40.4055",
      y1: "21.2163",
      x2: "30.1352",
      y2: "17.5676",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#9AEEF3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#82EBF1"
      })]
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_6155_3246",
      children: /*#__PURE__*/_jsx("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })]
  })]
}));
//# sourceMappingURL=Dynamics365BC.js.map